import type { Org, User } from "@api/types";
import useActiveOrg from "@ui/hooks/active-org";
import { useRouter } from "next/router";
import { ReactNode, useEffect } from "react";
import { AuthGate } from "./auth-gate";
import { FullscreenLoader } from "./fullscreen-loader";

export type { Org, User };

export type OrgGateProps = {
  children: ReactNode | ((props: { user: User; org: Org }) => ReactNode);
};

function OrgGateInner(props: OrgGateProps & { user: User }) {
  const { org, loading } = useActiveOrg();
  const router = useRouter();

  useEffect(() => {
    if (!loading && !org) {
      router.replace("/signup");
      return;
    }
  }, [org, loading, router]);

  if (!org) {
    return <FullscreenLoader />;
  }

  if (typeof props.children === "function") {
    return props.children({ user: props.user, org });
  }

  return props.children;
}

export function OrgGate(props: OrgGateProps) {
  return <AuthGate>{(_props) => <OrgGateInner {..._props} {...props} />}</AuthGate>;
}
